import React from 'react';

class MarketsSection extends React.Component {

    render() {
        let { data, products, showProductInfo, actions, isAdmin } = this.props;

        return (
            <div>
                <div className='manage-market-row'>
                    <div className='title'>{ data.name }</div>
                    <div
                        onClick={actions.showManageMarketPopup.bind(this, 'update', data)}
                        className='edit'>edit</div>
                    {isAdmin ?
                        <div
                            onClick={actions.deleteMarket.bind(this, data.id, data.name)}
                            className='delete'>delete</div>
                    : null}
                </div>
                <div className='manage-market-product-container'>
                { products && products.length ? products.map( item =>
                    <div
                        key={'product'+data.id+'_'+item.id}
                        className={item.hidden ?'manage-market-product-row-disabled': 'manage-market-product-row'}>

                        <div className='title'>{ item.short_name + ' ('+item.unit_name + ', ' + item.contract_type + ')'}</div>
                        <div
                            onClick={actions.showManageProductPopup.bind(this, 'update', data.id, item)}
                            className='edit'>edit</div>
                        <div
                            onClick={actions.deleteProduct.bind(this, item.id, item.name, actions.autoLogin)}
                            className='delete'>delete</div>
                        {item.hidden ?
                        <div
                            onClick={actions.hideProduct.bind(this, item.id, false, actions.autoLogin)}
                            className='edit'>unhide</div>  
                            : <div
                            onClick={actions.hideProduct.bind(this, item.id, true, actions.autoLogin)}
                            className='edit'>hide</div>  }
                    </div>
                ) : null }                    
                    <div
                        onClick={actions.showManageProductPopup.bind(this, 'create', data.id, '')}
                        className='manage-market-create-row'>Create new product</div>
                    <hr />
                </div>
            </div>
        )
    }
}
export default MarketsSection;



// WEBPACK FOOTER //
// ./source/screens/markets/manageMarketsSection.js